import React, { useRef, useState } from 'react';
import { Box } from '@mui/material';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const ProfilePictureCrop = ({ picture, setCroppedPicture }) => {
  const [crop, setCrop] = useState();
  const imageRef = useRef(null);
  const onImageLoad = (e) => {
    const { naturalWidth: width, naturalHeight: height } = e.currentTarget;

    imageRef.current = e.currentTarget;

    const cropSize = centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 50,
        },
        1,
        width,
        height
      ),
      width,
      height
    );

    setCrop(cropSize);
  };

  return (
    <Box>
      <Box p={1} width="100%">
        <ReactCrop
          keepSelection
          circularCrop
          aspect={1}
          crop={crop}
          onChange={(c) => setCrop(c)}
          onComplete={(c) => setCroppedPicture(c, imageRef.current)}
        >
          <img
            ref={imageRef}
            width="100%"
            style={{ maxHeight: '80vh', objectFit: 'cover' }}
            src={picture}
            alt="avatar"
            onLoad={onImageLoad}
          />
        </ReactCrop>
      </Box>
    </Box>
  );
};

export default ProfilePictureCrop;
